module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","forms"],"commonjs":"@angular/forms","commonjs2":"@angular/forms","amd":"@angular/forms"}
// module id = 5
// module chunks = 0 1